module.exports = __webpack_public_path__ + "static/media/Alba soffa 2,5-sits öppet avslut tyg Aragon light grey miljö 2024 fyrkant.1e663925.jpg";